import api from './index'

/**
 * 获取类别列表
 * @param {*} data
 * @returns
 */
export const getClassList = (data) => {
  return api({ url: '/admin/intentcate/lst', data })
}

/**
 * 删除自定义类别
 * @param {*} data
 * @returns
 */
export const deleteCustomIntent = (data) => {
  return api({ url: '/admin/intentcate/del', method: 'post', data })
}

/**
 * 编辑类别
 * @param {*} data
 * @returns
 */
export const editIntent = (data) => {
  return api({ url: '/admin/intentcate/edit', method: 'post', data })
}

/**
 * 编辑自定义类别
 * @param {*} data
 * @returns
 */
export const editCustomIntent = (data) => {
  return api({ url: '/admin/intentcate/effect', method: 'post', data })
}

/**
 * 获取槽值列表
 * @param {*} data
 * @returns
 */
export const getSlotList = (data) => {
  return api({ url: '/admin/slot/lst', data })
}
/**
 * 增加槽值
 * @param {*} data
 * @param {*} type
 * @returns
 */
export const addSlot = (data, type) => {
  return api({ url: `/admin/slot/${type}`, method: 'post', data })
}
/**
 * 改变槽值状态
 * @param {*} data
 * @returns
 */
export const changeSlotStatus = (data) => {
  return api({ url: '/admin/slot/slotstatus', method: 'post', data })
}
/**
 * 获取槽值取值
 * @param {*} data
 * @returns
 */
export const getSlotValList = (data) => {
  return api({ url: '/admin/slot/slotvallist', method: 'post', data })
}
/**
 * 删除槽值取值
 * @param {*} data
 * @returns
 */
export const deleteSlotVal = (data) => {
  return api({ url: '/admin/slot/delslotval', method: 'post', data })
}
/**
 * 增加槽值取值
 * @param {*} data
 * @returns
 */
export const addSlotVal = (data) => {
  return api({ url: '/admin/slot/addslotval', method: 'post', data })
}
/**
 * 获取意图列表
 * @param {*} data
 * @returns
 */
export const getIntentList = (data) => {
  return api({ url: '/admin/intent/lst', data })
}
/**
 * 获取关联列表
 * @param {*} data
 * @returns
 */
export const getCombineList = (data) => {
  return api({ url: '/admin/combine/see', method: 'post', data })
}
/**
 * 获取已关联
 * @param {*} data
 * @returns
 */
export const getCorrelation = (data) => {
  return api({ url: '/admin/intent/correlation', data })
}
/**
 * 切换意图状态
 * @param {*} data
 * @returns
 */
export const changeIntentStatus = (data) => {
  return api({ url: '/admin/intent/status/edit', method: 'post', data })
}
/**
 * 改变类别
 * @param {*} data
 * @returns
 */
export const changeAim = (data) => {
  return api({ url: '/admin/intent/cate/edit', method: 'post', data })
}
/**
 * 获取扩展问法列表
 * @param {*} data
 * @returns
 */
export const getExtendList = (data) => {
  return api({ url: '/admin/extend/lst', data })
}
/**
 * 删除扩展问法
 * @param {*} data
 * @returns
 */
export const deleteExtend = (data) => {
  return api({ url: '/admin/extend/del', method: 'post', data })
}
/**
 * 增加意图
 * @param {*} data
 * @returns
 */
export const addIntent = (data) => {
  return api({ url: '/admin/intent/add', method: 'post', data })
}
/**
 * 编辑快捷短语
 * @param {*} data
 * @returns
 */
export const addQuick = (data) => {
  return api({ url: '/admin/intent/editphrase', method: 'post', data })
}
/**
 * 增加扩展问法
 * @param {*} data
 * @returns
 */
export const addExtend = (data) => {
  return api({ url: '/admin/extend/add', method: 'post', data })
}
/**
 * 编辑意图关联
 * @param {*} data
 * @returns
 */
export const addRelative = (data) => {
  return api({ url: '/admin/combine/correlation', method: 'post', data })
}

/**
 * 关联槽值
 * @param {*} data
 * @returns
 */
export const addRelativeSlot = (data) => {
  return api({ url: '/admin/intent/associate/slot', method: 'post', data })
}
/**
 * 获取回复列表
 * @param {*} data
 * @returns
 */
export const getReplyList = (data) => {
  return api({ url: '/admin/answer/list', data })
}
/**
 * 获取槽值列表
 * @param {*} data
 * @returns
 */
export const getSlotLists = (data) => {
  return api({ url: '/admin/slot/slot/lst', data })
}
/**
 * 获取异常详情
 * @param {*} data
 * @returns
 */
export const getAnmalyDetail = (data) => {
  return api({ url: '/admin/anomaly/detail', method: 'post', data })
}
/**
 * 获取标准问
 * @param {*} data
 * @returns
 */
export const getStandard = (data) => {
  return api({ url: '/admin/extend/intent/standard', method: 'post', data })
}
/**
 * 编辑标准问法
 * @param {*} data
 * @returns
 */
export const editStandard = (data) => {
  return api({ url: '/admin/extend/standard', method: 'post', data })
}
/**
 * 编辑异常管理
 * @param {*} data
 * @returns
 */
export const editAnomaly = (data) => {
  return api({ url: '/admin/anomaly/add', method: 'post', data })
}
/**
 * 编辑回复管理
 * @param {*} data
 * @returns
 */
export const editReply = (data) => {
  return api({ url: '/admin/answer/reply', method: 'post', data })
}
/**
 * 删除回复
 * @param {*} data
 * @returns
 */
export const deleteReply = (data) => {
  return api({ url: '/admin/answer/del', data })
}

/**
 * 获取省份或招生类型
 * @param {*} type
 * @returns
 */
export const getTypeOrProvince = (type) => {
  return api({ url: `/admin/enroll/list/${type}` })
}

/**
 * 保存省份或招生类型
 * @param {*} data
 * @returns
 */
export const setTypeOrProvince = (data) => {
  return api({ url: '/admin/enroll/save', method: 'post', data })
}

/**
 * 获取快速问法列表
 * @param data 
 * @returns 
 */
export const getQuickAnswerList = (data) => {
  return api({ url: '/admin/quickAnswer/quickAnswerList', data })
}

/**
* 新增或编辑快速问法
* @param type 
* @param data 
* @returns 
*/
export const addQuickAnswer = (type, data) => {
  return api({ url: `/admin/quickAnswer/${type}`, method: 'post', data })
}

export const deleteQuick = (id) => {
  return api({ url: `/admin/quickAnswer/delQuickAnswer/${id}` })
}

/**
* 上传快速问答
* @param data 
* @returns 
*/
export const uploadQuick = (data) => {
  return api({ url: '/admin/quickAnswer/importQuickAnswer', method: 'post', data })
}

/**
 * 上传意图回复
 * @param {*} data 
 * @returns 
 */
export const uploadReply = (data) => {
  return api({ url: '/admin/answer/importReply', method: 'post', data })
}